// Form Configuration Constants

export const CREATE_INCIDENT_BREADCRUMB = [
  { name: "Incident Management", href: "/incident-management" },
  { name: "New Incident Report", href: "#" },
];
